
import { useEffect, useState } from 'react'
import { useAppContext } from '../../../context/AppContext'
import axios from 'axios'
import { formatDate } from '../../../util/FormatDate';
import { useNavigate } from 'react-router-dom';

const CustomerJob = ({company}) => {

  const {  axiUrl } = useAppContext();

  console.log(company)
const [jobs, setJobs] = useState([])
const nav=useNavigate()

useEffect(() => {
getprocessed()
},[])


const getprocessed = async() => {
await axios.post(`${axiUrl}/jobs/getjobsbycustomer`,{ id: company })
.then(res => {console.log(res.data);setJobs(res.data.message)})
.catch(err => console.log(err))

}


console.log(jobs);

















  return (
   <div className="bg-white dark:bg-gray-800 p-4 rounded-lg shadow-md mb-4 max-h-[calc(70vh-70px)] overflow-y-auto mt-8">
  <div className="flex items-center justify-between mb-3">
    <h2 className="text-base font-semibold text-gray-700 dark:text-gray-200">Active Jobs</h2>
    <button
onClick={ () => nav(`/dashboard/newjob/${company}`)}
      className="bg-blue-500 text-white px-2 py-1 rounded hover:bg-blue-600 text-sm"
    >
      New Job
    </button>
  </div>
  <div className="overflow-x-auto ">
    <table className="w-full text-left text-xs text-gray-700 dark:text-gray-200 cursor-pointer ">
      <thead>
        <tr className="border-b dark:border-gray-700">
          <th className="py-1.5 px-3">Job ID</th>
          <th className="py-1.5 px-3">Description</th>
          <th className="py-1.5 px-3">Process Date</th>
          <th className="py-1.5 px-3">Quantity</th>
          <th className="py-1.5 px-3">Format</th>
          <th className="py-1.5 px-3"></th>
          <th className="py-1.5 px-3 w-48"></th>
        </tr>
      </thead>
      <tbody>
     {jobs?.map(job => {
       return  <tr
          className="border-b dark:border-gray-700 hover:bg-gray-50 dark:hover:bg-gray-700"
          onClick={() => nav(`/dashboard/job/${job?._id}`)}
            
          >
            <td className="py-1.5 px-3">{job?.jobId}</td>
            <td className="py-1.5 px-3">{job?.jobDescription}</td>
            <td className="py-1.5 px-3">{formatDate(job.createdAt)}</td>
            <td className="py-1.5 px-3">{job?.processedrecordCount}</td>
            <td className="py-1.5 px-3">{job?.job_format}</td>
            <td className="py-1.5 px-3" ></td>
            <td className="py-1.5 px-3 font-bold w-48" >
            
                <button
                  className="bg-blue-400 text-white font-semibold border-1 py-1 px-4 z-140 cursor-pointer"
                >
                  Send To Post Office
                </button>
           
            </td>
          </tr>
        
     })}
         
   
      </tbody>
    </table>
  </div>
</div>
  )
}

export default CustomerJob